import React, { Component } from "react";
import { Link } from "react-router-dom";
import Notification from "../components/Notification";
import apiClient from "../lib/apiClient";
class Welcome extends Component{
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.location.pathname.substr(1),
      place: "",
      day: "",
      ongoing: false,
      isLoading: true
    }
  }

  async componentDidMount() {
    const gig = await apiClient.getGig();
    if (gig) {
      const { place, day, songs, ongoing } = gig;
      return this.setState({ isLoading: false, place, day, songs, ongoing });
    } else {
      return this.setState({isLoading: false})
    }
  }

  render() {
    const { place, day, lang, ongoing, isLoading } = this.state;
    const question = {
      cat: "Quines cançons vols que toquem?",
      cas: "¿Qué canciones quieres que toquemos?",
      en: "Which songs do you want us to play?",
      fr: "Quelles chansons voulez-vous que nous jouions?",
      de: "Welche Lieder sollen wir spielen?"
    }
    const vote = {
      cat: "Vota",
      cas: "Vota",
      en: "Vote",
      fr: "Voter",
      de: "Abstimmung"
    }
    const notOnline = {
      cat: "Ara no estem en directe, però...",
      cas: "Ahora no estamos en directo, pero...",
      en: "We are not currently live, but...",
      fr: "Nous ne sommes pas en direct, mais...",
      de: "Wir sind derzeit nicht live, aber..."
    }
    
    if (isLoading) {
      return <p className="main h-2/3">Loading...</p>
    }

    return (
      <div className="main h-2/3">
        {ongoing ?
        <div className="h-2/3 flex flex-col text-center justify-around">
          <div>
            <p className="text-3xl">{place}</p>
            <p className="text-xl">{day}</p>
          </div>
          <h2>{question[lang]}</h2>
          <Link to={`/${lang}/vote`}><button className="button" >{vote[lang]}</button></Link>
        </div>
          :
          <div className="text-center">
            <p className="pt-10">{notOnline[lang]}</p>
            <Notification fixed lang={lang} />
          </div>
          }
        </div>
    )
  }
}

export default Welcome;